import { t } from '@web/i18n';
import { PageSectionHead } from '@web/ui/core';
import { twcn } from '@web/ui/core/utils';

import {
  JitBanner,
  MembersDrawer,
  MembersTable,
  MembersToolbar,
  StatsRow,
} from '@web/ui/members/components';
import { useMembersPage } from '@web/ui/members/hooks';

export default function MembersPage(): React.JSX.Element | null {
  const ctrl = useMembersPage();

  if (!ctrl.isReady || !ctrl.org) return null;

  return (
    <div
      className={twcn(
        'grid min-h-0 min-w-0 items-stretch',
        ctrl.active ? 'grid-cols-[minmax(0,1fr)_var(--drawer-w)]' : 'grid-cols-[minmax(0,1fr)]',
      )}
    >
      <div className="min-h-0 min-w-0">
        <PageSectionHead
          title={t('members.page.title.em')}
          sub={
            <>
              {t('members.page.ledeBefore')}
              <strong className="font-medium text-foreground">
                {t('members.page.ledeAutoJoin')}
              </strong>
              {t('members.page.ledeMiddle')}
              <span className="font-mono text-foreground">{t('members.page.ledeSourceTag')}</span>
              {t('members.page.ledeAfter')}
              <strong className="font-medium text-foreground">
                {t('members.page.ledeRoleTag')}
              </strong>
              {t('members.page.ledeTail')}
            </>
          }
        />
        <StatsRow stats={ctrl.stats} />
        <JitBanner org={ctrl.org} onToggle={ctrl.toggleJit} />
        <MembersToolbar
          query={ctrl.query}
          setQuery={ctrl.setQuery}
          domain={ctrl.domain}
          setDomain={ctrl.setDomain}
          role={ctrl.role}
          setRole={ctrl.setRole}
          status={ctrl.status}
          setStatus={ctrl.setStatus}
          sort={ctrl.sort}
          setSort={ctrl.setSort}
          allDomains={ctrl.allDomains}
        />
        <MembersTable members={ctrl.filtered} activeId={ctrl.activeId} onOpen={ctrl.setActiveId} />
      </div>
      {ctrl.active ? (
        <MembersDrawer
          member={ctrl.active}
          canChangeRole={ctrl.canChangeRole}
          canChangeStatus={ctrl.canChangeStatus}
          canRemove={ctrl.canRemove}
          canGrantMcp={ctrl.canGrantMcp}
          onClose={() => {
            ctrl.setActiveId(null);
          }}
          onChangeRole={ctrl.changeRole}
          onSetStatus={ctrl.setMemberStatus}
          onRemove={ctrl.removeMember}
          onSetMcpAccess={ctrl.setMcpAccess}
        />
      ) : null}
    </div>
  );
}
